module.exports = __webpack_public_path__ + "img/img50.76ab53dc.svg";